// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3uulS","log":"ModalInventoryLogs_log__1fGJr","date":"ModalInventoryLogs_date__2jJ8d","userName":"ModalInventoryLogs_userName__14r75"};